document.addEventListener('DOMContentLoaded', function () {
  const cardImages = document.querySelectorAll('[data-card-images]');
  cardImages.forEach(function (script) {
    try {
      // Trim whitespace and check if content exists
      const textContent = script.textContent.trim();
      if (!textContent) {
        console.warn('Empty data-card-images element');
        return;
      }

      const jsonData = JSON.parse(textContent);

      // Validate jsonData is an array
      if (!Array.isArray(jsonData)) {
        console.warn('data-card-images is not an array:', jsonData);
        return;
      }

      const select = script.closest('.item').querySelector('select');
      if (select) {
        const options = select.querySelectorAll('option');
        options.forEach(function (option, index) {
          if (jsonData[index] && jsonData[index].src) {
            option.setAttribute('data-featured-image', jsonData[index].src);
          }
        });
      }
    } catch (error) {
      console.error('Error parsing data-card-images JSON:', error, script.textContent);
    }
  });
});
